import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-591ea2d1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "containerDetailBox"
};
const _hoisted_2 = {
  class: "containerDetailCards"
};
const _hoisted_3 = {
  class: "nav_status"
};
const _hoisted_4 = {
  class: "nav_select_box"
};
const _hoisted_5 = {
  class: "nav_select"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "content"
};
const _hoisted_8 = {
  key: 1,
  class: "list render-hide-scroll"
};
const _hoisted_9 = {
  class: "card_list"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "over_card"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "bottom"
};
const _hoisted_15 = {
  key: 0,
  class: "double"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "check"
}, null, -1));
const _hoisted_17 = {
  class: "title render-font-family"
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  class: "bottom_op"
};
const _hoisted_20 = {
  class: "bottom_total"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "已选：", -1));
const _hoisted_22 = {
  key: 0,
  class: "select-total"
};
const _hoisted_23 = {
  class: "postage"
};
const _hoisted_24 = {
  class: "bottom_btns"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_search = _resolveComponent("search");
  const _component_Error = _resolveComponent("Error");
  const _component_list = _resolveComponent("list");
  const _component_icon = _resolveComponent("icon");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  const _component_BigImage = _resolveComponent("BigImage");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_action_sheet, {
    show: $options.showCards,
    "onUpdate:show": _cache[8] || (_cache[8] = $event => $options.showCards = $event),
    title: $props.activity_name,
    onOpen: $options.open,
    "close-icon": $data.closeIcon,
    onClose: $options.closeCards,
    "close-on-click-overlay": false
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
      class: "search",
      onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => _ctx.goSearch && _ctx.goSearch(...args), ["stop"]))
    }, [_createVNode(_component_search, {
      modelValue: $data.card_name,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.card_name = $event),
      "show-action": "",
      placeholder: "输入名称、编号",
      onSearch: $options.onSearch
    }, {
      action: _withCtx(() => [_createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = (...args) => $options.onClickButton && $options.onClickButton(...args))
      }, "搜索")]),
      _: 1
    }, 8, ["modelValue", "onSearch"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.nav, (item, index) => {
      return _openBlock(), _createElementBlock("p", {
        class: _normalizeClass({
          'active': $data.level_name == item.level_name
        }),
        key: index,
        onClick: _withModifiers($event => $options.changeNav(item.level_name), ["stop"])
      }, _toDisplayString(item.level_name), 11, _hoisted_6);
    }), 128))])])]), _createElementVNode("div", _hoisted_7, [$data.total == 0 && $data.page == 1 ? (_openBlock(), _createBlock(_component_Error, {
      key: 0,
      message: $data.showMessage
    }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_list, {
      loading: $data.loading,
      "onUpdate:loading": _cache[3] || (_cache[3] = $event => $data.loading = $event),
      "immediate-check": false,
      onLoad: $options.onLoad
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.card_detail_list, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "list_item",
          key: index
        }, [_createElementVNode("div", {
          class: _normalizeClass(['bg', {
            'active': item.can_deliver_goods && item.select
          }, {
            'disabled': !item.can_deliver_goods
          }]),
          onClick: _withModifiers($event => $options.checkCard({
            item: item,
            index: index
          }), ["stop"])
        }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
          src: `${_ctx.$imgUrlFilter(item.card_img_url, 220)}`
        }, null, 8, _hoisted_12), _createElementVNode("div", {
          class: "meng",
          onClick: _withModifiers($event => $options.showBigImage(index), ["stop"])
        }, null, 8, _hoisted_13), _createElementVNode("div", _hoisted_14, _toDisplayString(item.level_name), 1), item.card_back_img_url ? (_openBlock(), _createElementBlock("div", _hoisted_15, "多图")) : _createCommentVNode("", true), _hoisted_16])], 10, _hoisted_10), _createElementVNode("p", _hoisted_17, _toDisplayString(item.card_name), 1), item.deposit_days > 1 ? (_openBlock(), _createElementBlock("span", _hoisted_18, "免费寄存剩 " + _toDisplayString(item.deposit_days) + "天", 1)) : _createCommentVNode("", true)]);
      }), 128))])]),
      _: 1
    }, 8, ["loading", "onLoad"])]))]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_hoisted_21, $data.showTotal && $data.select_total > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("span", null, _toDisplayString($data.select_total) + "张", 1), _createElementVNode("div", {
      class: "total-close",
      onClick: _cache[4] || (_cache[4] = (...args) => $options.cancelCheck && $options.cancelCheck(...args))
    }, [_createVNode(_component_icon, {
      name: "cross"
    })])])) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_23, _toDisplayString($options.postage_detail), 1)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", {
      class: "btn all",
      onClick: _cache[5] || (_cache[5] = _withModifiers($event => $options.checkCard({
        type: 'all'
      }), ["stop"]))
    }, "全选"), $props.canChooseMore ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "btn all",
      onClick: _cache[6] || (_cache[6] = _withModifiers((...args) => $options.continueCards && $options.continueCards(...args), ["stop"]))
    }, "继续选择")) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "btn",
      onClick: _cache[7] || (_cache[7] = _withModifiers((...args) => $options.deliver && $options.deliver(...args), ["stop"]))
    }, "申请发货")])])])]),
    _: 1
  }, 8, ["show", "title", "onOpen", "close-icon", "onClose"]), _createVNode(_component_BigImage, {
    show: $data.bigImageVisible,
    init: $data.bigInitIndex,
    list: $data.img_list,
    onClose: _cache[9] || (_cache[9] = $event => $data.bigImageVisible = false)
  }, null, 8, ["show", "init", "list"])]);
}